
import { BasicDialogHandler } from "@goodgamestudios/core";
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2StarterPackageTeaserDialog } from "../../../view/dialogs/starterPackages/Poker2StarterPackageTeaserDialog";
import { Poker2StarterPackageTeaserDialogProperties } from "../../../view/dialogs/starterPackages/Poker2StarterPackageTeaserDialogProperties";
import { Poker2Command } from "../Poker2Command";

export class SPTCommand extends Poker2Command {
    protected get cmdId(): string {
        return SFConstants.S2C_STARTER_PACKAGE_TEASER;
    }

    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            var paramObj: any = JSON.parse(params[1]);

            // parse starter packages
            Poker2Model.itemShop.parse_sps(paramObj);

            // create starter package teaser dialog
            BasicDialogHandler.getInstance().registerDialogs("Poker2StarterPackageTeaserDialog", new Poker2StarterPackageTeaserDialogProperties(paramObj.timeleft), true, BasicDialogHandler.PRIORITY_LOW);
        }
        return super.executeCommand(error, params);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
